var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.138 3h-4.983L10.33 13.707c-1.273 1.06-4.984.954-5.514-2.12-.53-3.075 1.484-4.559 3.498-4.559 1.612 0 3.004 1.626 3.499 2.438l3.286-2.438c-.885-1.236-3.415-3.71-6.467-3.71C4.816 3.318 1 5.544 1 9.466c0 3.923 1.696 6.467 3.816 7.633 2.12 1.165 5.089.953 7.315-.001 1.782-.764 11.414-9.718 16.008-14.1zM3.862 28.92h4.983L21.67 18.215c1.274-1.06 4.984-.954 5.514 2.12.53 3.074-1.484 4.559-3.499 4.559-1.61 0-3.003-1.626-3.498-2.439l-3.286 2.438c.885 1.237 3.415 3.71 6.468 3.71 3.816 0 7.632-2.225 7.632-6.148 0-3.922-1.696-6.466-3.816-7.632-2.12-1.166-5.089-.954-7.315 0-1.782.763-11.414 9.717-16.008 14.099z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYld);
export default __webpack_public_path__ + "static/media/YLD.67204ef4ab6ecf2fc3ed4a504f0d651d.svg";
export { ForwardRef as ReactComponent };